import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {ConnectedRouter} from 'react-router-redux';

import Questionnaire from '../frontend/questionnaires/components/Questionnaire';
import Home from 'cov-social/Home';

const App = ({history}) => (
    <ConnectedRouter history={history}>
        <Switch>
            <Route path="/" exact component={Home} />
            <Route
                path="/:questionnaire/"
                exact
                render={({match: {params: {questionnaire}}}) => (
                    <Questionnaire id={questionnaire} />
                )}
            />
        </Switch>
    </ConnectedRouter>
);

export default App;



// WEBPACK FOOTER //
// ./scripts/cov-social/App.js